export const SHOP_ENV = {
  PROD: 'prod',
  QS: 'qs',
} as const

export type SHOP_ENV = (typeof SHOP_ENV)[keyof typeof SHOP_ENV]

export const TENANT = {
  AT: 'at',
  BE: 'be',
  CH: 'ch',
  COM: 'com',
  FR: 'fr',
  IT: 'it',
} as const

export type TENANT = (typeof TENANT)[keyof typeof TENANT]

export const TENANT_AND_ENV = {
  AT: 'at',
  AT_QS: 'at-qs',
  BE: 'be',
  BE_QS: 'be-qs',
  CH: 'ch',
  CH_QS: 'ch-qs',
  COM: 'com',
  COM_QS: 'com-qs',
  FR: 'fr',
  FR_QS: 'fr-qs',
  IT: 'it',
  IT_QS: 'it-qs',
} as const

export type TENANT_AND_ENV =
  (typeof TENANT_AND_ENV)[keyof typeof TENANT_AND_ENV]

export interface TenantData {
  shopEnv: SHOP_ENV
  tenant: TENANT
  tenantAndEnv: TENANT_AND_ENV
}

export const tenantToLocaleRegionMap = {
  [TENANT.AT]: 'AT',
  [TENANT.BE]: 'BE',
  [TENANT.CH]: 'CH',
  [TENANT.COM]: 'DE',
  [TENANT.FR]: 'FR',
  [TENANT.IT]: 'IT',
} as const

export const tenantToVatPrefix = {
  [TENANT.AT]: 'ATU',
  [TENANT.BE]: 'BE',
  [TENANT.CH]: 'CHE',
  [TENANT.COM]: 'DE',
  [TENANT.FR]: 'FR',
  [TENANT.IT]: 'IT',
}
